import { render, staticRenderFns } from "./Messaging.vue?vue&type=template&id=4bf97dea"
import script from "./Messaging.vue?vue&type=script&lang=js"
export * from "./Messaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf97dea')) {
      api.createRecord('4bf97dea', component.options)
    } else {
      api.reload('4bf97dea', component.options)
    }
    module.hot.accept("./Messaging.vue?vue&type=template&id=4bf97dea", function () {
      api.rerender('4bf97dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/feedback/Messaging.vue"
export default component.exports